import { PrintSettings } from '../types';

type DishNameFormatData = {
  name: string;
  output?: number | null;
  servingsCount?: number | null;
};

const formatOutputLabel = (output?: number | null) => {
  const value = Number(output ?? 0);
  if (!Number.isFinite(value) || value <= 0) return '';
  return `${value.toFixed(3).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1')} г`;
};

const formatServingsLabel = (servingsCount?: number | null) => {
  const value = Number(servingsCount ?? 0);
  if (!Number.isFinite(value) || value <= 0) return '';
  return `${Math.round(value)} порц.`;
};

export const formatDishName = (
  data: DishNameFormatData,
  settings?: PrintSettings | null
) => {
  const baseName = data.name?.trim() || '';
  if (!baseName) return '';

  const output = formatOutputLabel(data.output);
  const servings = formatServingsLabel(data.servingsCount);
  const fallbackAppendOutput = settings?.appendOutputToDishName ?? false;
  const fallbackAppendServings = settings?.appendServingsToDishName ?? false;
  const format = settings?.dishNameFormat?.trim() || '{name}';

  const rendered = format
    .replaceAll('{name}', baseName)
    .replaceAll('{output}', output)
    .replaceAll('{servings}', servings)
    .replace(/\s{2,}/g, ' ')
    .replace(/\(\s*[;,]?\s*\)/g, '')
    .replace(/\[\s*[;,]?\s*\]/g, '')
    .replace(/\s+([,;:)])/, '$1')
    .replace(/\(\s+/g, '(')
    .trim();

  if (rendered && rendered !== baseName) return rendered;

  const suffixes = [
    fallbackAppendOutput ? output : '',
    fallbackAppendServings ? servings : '',
  ].filter(Boolean);

  return suffixes.length > 0 ? `${baseName} (${suffixes.join('; ')})` : baseName;
};
